import { Dispatch } from "react";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import restUrls from "web/constants/restUrls";

import { request } from "web/api";

import handleCodeSessionStorageAction, {
  CodeActionType,
} from "./handleCodeSessionStorageAction";

type GetBarcodeArgs = {
  itemId: number;
  setBarcode: Dispatch<React.SetStateAction<string | null>>;
};

type GetBarcodeFN = (args: GetBarcodeArgs) => void;

const getBarcode: GetBarcodeFN = async ({ itemId, setBarcode }) => {
  try {
    const response = await request(
      `${restUrls.barCodeImage}?itemId=${Number(itemId)}`
    );
    const barCode = `data:image/png;base64,${response}`;
    handleCodeSessionStorageAction({
      itemId,
      action: CodeActionType.SET_BARCODE,
      value: barCode,
    });
    setBarcode(barCode);
  } catch (error) {
    console.error(error);
    newRelicErrorReport(
      error,
      "web-app/web/Components/Common/CodeItem/CodeModal/utils/getBarcode.ts - 36"
    );
  }
};

export default getBarcode;
